import { Link } from "react-router-dom";
import { toast } from "react-toastify";

import { AUTH_API } from "../../../../api/auth";
import { GoogleIcon } from "../../../../components/Icons";
import { gmailPattern } from "../../ResetPassword/constants.ts";

import { AuthStepComponentProps } from "../../types.ts";
import { LoginStep } from "../types.ts";

const EmailVerification = ({
  setStep,
  email,
}: AuthStepComponentProps<LoginStep>) => {
  const resendVerification = async () => {
    if (email) {
      const { data } = await AUTH_API.resendVerification(email);
      if (data) {
        if (data?.message) {
          toast.success(data.message);
        }
        setStep("initial");
      }
    }
  };

  return (
    <>
      <p className="text-center leading-[1.71] text-white">
        Verify your email
        <p className="p-2 text-center text-sm text-black/50 dark:text-white/50">
          We sent an email to {email}
        </p>
      </p>
      {email && gmailPattern.test(email) && (
        <a
          href="https://www.gmail.com/mail"
          target="_blank"
          rel="noopener noreferrer nofollow"
          className="appearAnimation flex h-[3rem] w-full items-center rounded-[2.5rem] bg-white p-[1rem] text-[0.875rem] leading-[1.71] text-black dark:text-neutral-800"
          onClick={() => setStep("initial")}
        >
          <span className="flex-grow text-center">Open Gmail</span>
          <GoogleIcon />
        </a>
      )}

      <p className="appearAnimation flex items-center justify-center gap-[1rem] font-Mulish text-[0.875rem] leading-[1.29rem]  text-black/50 dark:text-white/50">
        Didn’t receive?
        <Link
          to="/login"
          className="text-black dark:text-white"
          onClick={resendVerification}
        >
          Resend email
        </Link>
      </p>
    </>
  );
};

export default EmailVerification;
